export enum NotificationLocalStorageKey {
  NOTIFICATION_ONLY_SHOW_UNREAD = 'notificationOnlyShowUnread',
}
